export default __webpack_public_path__ + "static/media/chalDal.2c76d8bf.png";